/**
 * Build a {@link TraceContextExtractor} from an OpenTelemetry API object.
 *
 * The extractor injects the active context into a fresh carrier on every
 * call and returns the W3C trace headers found there. When there is no
 * `traceparent`, it returns null for an empty carrier (no active trace) or
 * a headerless result carrying only {@link TraceExtractionResult.carrierKeys}
 * when the propagator wrote non-W3C headers. Returns null when the API
 * throws.
 */
export function createTraceContextExtractor(otel) {
    return () => {
        try {
            const carrier = {};
            otel.propagation.inject(otel.context.active(), carrier);
            const traceparent = carrier['traceparent'];
            if (!traceparent) {
                const carrierKeys = Object.keys(carrier);
                if (carrierKeys.length === 0) {
                    return null;
                }
                return { carrierKeys };
            }
            return {
                traceparent,
                tracestate: carrier['tracestate'],
                baggage: carrier['baggage'],
            };
        }
        catch (_a) {
            return null;
        }
    };
}
//# sourceMappingURL=create-extractor.js.map